<div class="monitor-license-status">
  <div class="row">
    <h4>License Status</h4>
    <div>
        <span [ngClass]="{ error: this.isLicenseExceeded() }">
          {{licenses.inUse}}
        </span> <span class="gray">of {{licenses.max}}</span> used
    </div>
  </div>

  <div class="progress total">
    <div
      [ngClass]="getUsedMonitorsPercent()<= 80 ? 'below80' : (getUsedMonitorsPercent() < 100 ? 'above80' : 'max')"
      [ngStyle]="{width: getUsedMonitorsPercent() + '%'}"></div>
  </div>
</div>
